var React = require('react');

function Linkedin2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 12h5.535v2.837h0.079c0.77-1.381 2.655-2.837 5.464-2.837 5.842 0 6.922 3.637 6.922 8.367v9.633h-5.769v-8.54c0-2.037-0.042-4.657-3.001-4.657-3.005 0-3.463 2.218-3.463 4.509v8.688h-5.767v-18z","key":0}),React.createElement("path",{"d":"M2 12h6v18h-6v-18z","key":1}),React.createElement("path",{"d":"M8 7c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z","key":2})]);
}

Linkedin2.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","version":"1.1"};

module.exports = Linkedin2;

Linkedin2.default = Linkedin2;
